module.exports = __webpack_public_path__ + "static/CalibreWeb-Semibold-fa3017bd581c775de411b38a3afe86f1.eot";